import {
    Card,
    Button,
    Loading,
    BaseTable,
    ActionButton,
} from "components"
import { useProfileDetail } from "../utils/useProfileDetail"
import moment from "moment"
import { useEffect, useState } from "react"
import { FormStateProjectProfile } from "../types/ProfileTypes"
import { Controller, FormProvider, useFieldArray, useForm } from "react-hook-form"
import { FormBoqType, validationFormBoqSchema } from "../types/BoqTypes"
import { convertNumber, useApi } from "utils"
import { TableItem } from "../components/TableItem"
import { yupResolver } from "@hookform/resolvers/yup"
import { useVendorList } from "../utils/useVendorList"
import toast from "react-hot-toast"
import { useBoqDetail } from "../utils/useBoqDetail"
import { PROJECT_STATUS_OPTIONS } from "../utils/projectTypeOption"

interface TabBoqProps{
    action?:string
    project_id?:string
    approval_view?:boolean
    data_profile?:FormStateProjectProfile
}

export function TabBoq(props:TabBoqProps): JSX.Element {
    const isDisabledForm = Boolean(props.action === 'view')
    const api = useApi()
    const vendor = useVendorList()
    const defaultValues = {
        data_boq: []
    }
    const methods = useForm<FormBoqType>({
        defaultValues,
        resolver:yupResolver(validationFormBoqSchema)
    })
    const { handleSubmit, watch, setValue } = methods;
    const  data_boq = watch("data_boq")
    
    const [editField, setEditField] = useState<number | null>(null)

    const { fields, append, remove } = useFieldArray({
        control: methods.control,
        name: "data_boq"
    })
    const [isLoading , setLoading] = useState(true)
    const { data } = useProfileDetail(props.project_id)
    const { detailBoq, refetchBoq } = useBoqDetail(props.project_id)
    const [dataProfile, setDataProfile] = useState<FormStateProjectProfile | null>(null);
    const [dayBehind,setDayBehind ] = useState(0)
    const [weekBehind,setWeekBehind ] = useState(0)
    const totalBudget = data_boq?.reduce((acc, item) => acc + (Number(item.budget) || 0), 0);
    const totalActual = data_boq?.reduce((acc, item) => acc + (Number(item.actual) || 0), 0);
        
    
    useEffect(() => {
        if (isLoading && ((!data || data.length === 0) || !detailBoq)) return;

        setDataProfile(data[0])
        setValue('data_boq',detailBoq)
        const startDate = data[0].start_date;
        const dueDate = data[0].due_date;
        const today = moment().toDate()
        // Hitung durasi (hari)
        const dayBehind = startDate ? moment(dueDate).diff(moment(today), "days") : 0;
        let weekBehind =  startDate ? moment(today).diff(moment(startDate), "days") : 0;
        weekBehind = Math.ceil(weekBehind / 7 );
        
        setDayBehind(dayBehind)
        setWeekBehind(weekBehind)
        setLoading(false)
        // eslint-disable-next-line
    },[data, detailBoq])
    

    const onSubmit = async (value: FormBoqType) => {
        await toast
        .promise(api.post("/project/saveboq/", value.data_boq), {
            loading: "Loading...",
            success: (res) => {
                console.log(res.data);
                return res.data.message
            },
            error: (err) => err.response.data.detail?.message ?? err.response.data.message
        })
        .then(() => {
            refetchBoq()
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        })
        .catch((err) => {
            throw new Error(err);
        });
    };

    const onError = (errors: any) => {
        Object.values(errors).forEach((error: any) => {
            if (error?.message) {
                toast.error(error.message)
            } else if (typeof error === 'object') {
                Object.values(error).forEach((subError: any) => {
                    if (subError?.message) toast.error(subError.message)
                })
            }
        })
    };

    if(isLoading) return (
        <Loading
        loading={isLoading}
        errorText="No data available"
      />
    )

    return (
        <section className="">
            <section>
                <Card>
                    <Card.Body>
                      
                        <div className="flex flex-row w-full"> 
                            <div className="grow">
                                <div className="text-2xl font-bold uppercase py-4">
                                    {dataProfile?.project_name}
                                </div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>START DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.start_date) ? moment(dataProfile.start_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                        <tr>
                                            <td>DUE DATE</td>
                                            <td>:</td>
                                            <td>{(dataProfile?.due_date) ? moment(dataProfile.due_date).format('DD/MM/YYYY') : '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="flex gap-2">
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">DURATION | DAYS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{dayBehind}</span>
                                        <span className="text-sm">Leaf of days</span>
                                    </section>
                                </div>
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">START | WEEKS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{weekBehind}</span>
                                        <span className="text-sm">Weeks</span>
                                    </section>
                                </div>
                            </div>
                        </div>
                 
                    </Card.Body>
                </Card>
            </section>

            <section>
            <FormProvider {...methods}>
                <Card>
                    <Card.Body>
                        <div>
                            <BaseTable>
                                <thead className="!bg-black !text-white">
                                    <tr>
                                        <th>NO</th>
                                        <th>BOQ</th>
                                        <th>DESCRIPTION</th>
                                        <th>RESOURCE</th>
                                        <th>BUDGET</th>
                                        <th>ACTUAL</th>
                                        <th>VARIANCE</th>
                                        <th>START DATE</th>
                                        <th>DUE DATE</th>
                                        <th>FILE</th>
                                        <th>STATUS</th>
                                        <th>CHECK DATE</th>
                                        <th>ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fields.map((arrField, key) => {
                                        return (
                                                <Controller
                                                    key={arrField.id}
                                                    control={methods.control}
                                                    name={`data_boq.${key}`}
                                                    render={({ field }) => {
                                                    if (editField === key) {
                                                        return (
                                                            <TableItem
                                                                dataProject={dataProfile!}
                                                                vendor={vendor}
                                                                key={arrField.id}
                                                                index={editField}
                                                                action="edit"
                                                                isHideForm={false}
                                                                defaultValues={field.value}
                                                                onCancelEditing={() => setEditField(null)}
                                                                onSubmitData={(value) => {
                                                                    field.onChange({ ...field.value, ...value })
                                                                    setEditField(null)
                                                                }}
                                                            />
                                                            
                                                        )
                                                    } else {
                                                        let variance = field.value.actual ? (Number(field.value.budget) - Number(field.value.actual))/ Number(field.value.budget) * 100 : 0;
                                                        variance = Math.round(variance);
                                                        return (
                                                            <tr>
                                                                <td className="text-center">{key + 1}</td>
                                                                <td>{field.value.boq_name}</td>
                                                                <td>{field.value.description}</td>
                                                                <td>{field.value.vendor_name ?? ''}</td>
                                                                <td className="text-right">{convertNumber(field.value.budget).intoCurrency}</td>
                                                                <td className="text-right">{(field.value.actual) ? convertNumber(field.value.actual).intoCurrency : ''}</td>

                                                                <td className={`text-right ${variance < 0 ? 'text-red-700' : variance > 0 ? 'text-success' : 'text-blue-700'}`}>{(field.value.actual) ? `${convertNumber(variance).intoNormalAmount}%` : '' }</td>
                                                                <td>{(field.value.start_date) ? moment(field.value.start_date).format('DD/MM/YYYY'): ''}</td>
                                                                <td>{(field.value.due_date) ? moment(field.value.due_date).format('DD/MM/YYYY'): ''}</td>
                                                                <td>
                                                                  <div className="flex flex-col gap-1">
                                                                    {(field.value.project_file ?? []).map((file: any) => (
                                                                      <a
                                                                        key={file.project_file_id}
                                                                        href={`${process.env.REACT_APP_BASE_URL_API}/getimage/?imgpath=${file.path}`}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                        className="text-blue-600 hover:underline text-sm truncate max-w-[160px] block"
                                                                        title={file.project_file_name}
                                                                      >
                                                                        {file.project_file_name}
                                                                      </a>
                                                                    ))}
                                                                  </div>
                                                                </td>
                                                                <td>{PROJECT_STATUS_OPTIONS.find(o => Number(o.value) === (field.value as any).checklist_status)?.label ?? '-'}</td>
                                                                <td>{(field.value as any).checklist_date ? moment((field.value as any).checklist_date).format('DD/MM/YYYY') : '-'}</td>
                                                                <td>
                                                                <section className="flex justify-center items-center">
                                                                    {!isDisabledForm && (
                                                                        <>
                                                                            <ActionButton.Update
                                                                                permission="AT021"
                                                                                onClick={() => setEditField(key)}
                                                                            />
                                                                            <ActionButton.Delete
                                                                                permission="AT021"
                                                                                onClick={() => remove(key)}
                                                                            />
                                                                        </>
                                                                    )}
                                                                    
                                                                </section>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                    }}
                                                />
                                           
                                        )
                                    })}

                                    {!isDisabledForm && (
                                    <TableItem
                                        dataProject={dataProfile!}
                                        key={fields.length}
                                        vendor={vendor}
                                        action="add"
                                        onSubmitData={(value) => append(value)}
                                    />
                                    )}
                                </tbody>
                            </BaseTable>
                        </div>
                        <div className="flex mt-5">
                            <div className="grow"></div>
                            <div>
                                <table className="table">
                                    <tbody className="font-bold">
                                        <tr>
                                            <td>TOTAL BUDGET</td>
                                            <td className="min-w-[5px] text-center">:</td>
                                            <td className="min-w-[100px] text-right">{convertNumber(Number(totalBudget)).intoCurrency}</td>
                                        </tr>
                                        <tr>
                                            <td>ACTUAL BUDGET</td>
                                            <td className="min-w-[5px] text-center">:</td>
                                            <td className="min-w-[100px] text-right">{convertNumber(Number(totalActual)).intoCurrency}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="flex justify-end mt-[30px] mb-[30px]">
                            <Button color="primary" 
                                disabled={isDisabledForm}
                                className="min-w-[100px]"
                                type="button"
                                permission="ST19"
                                onClick={handleSubmit(onSubmit, onError)}
                            >
                                { props.action === 'edit' ? 'SAVE': 'CREATE'}
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </FormProvider>

            </section>
        </section>
    )
}
